import { render } from "./tab-booking-in-progress.vue?vue&type=template&id=4e7d6bf1&scoped=true&ts=true"
import script from "./tab-booking-in-progress.vue?vue&type=script&lang=ts"
export * from "./tab-booking-in-progress.vue?vue&type=script&lang=ts"

import "./tab-booking-in-progress.vue?vue&type=style&index=0&id=4e7d6bf1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7d6bf1"]])

export default __exports__